import React from "react";
import { Typography, Select, MenuItem, InputLabel, Grid, Chip } from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import DataField from "../Datafield";
import MappedText from "../../reports/create-report/shared-components/mapText";
import { convertDate } from "../../reports/create-report/sections/utils";
import { uniqueStatusDic, uniquePriorityDic } from "../configDirOverview";




export default function GeneralInfo({
    allDataApis,
    selectedDir,
    analysisTypeLabel,
    selectedStatus,
    handleChangeStatus,
    selectedPriority,
    handleChangePriority
  }) {
    return (
      <>
        <Typography variant={"h5"} style={{ fontWeight: "700", marginBottom: "20px" }}>
          <MappedText text={"General Info"} />
        </Typography>
  
        <Grid container spacing={2} sx={{ marginBottom: 4 }}>
          <Grid item xs={12} sm={4} md={3}>
            <DataField title="Request ID" value={allDataApis?.dirs?.dir_id || "NA"} />
          </Grid>
  
          {selectedDir && (
            <Grid item xs={12} sm={4} md={3}>
              <DataField title="Description" value={selectedDir?.comments || "NA"} />
            </Grid>
          )}
  
          <Grid item xs={12} sm={6} md={6}>
            <Typography sx={{ color: "#626262", fontWeight: "400", fontSize: "14px" }}>
              <MappedText text={"Analysis Type"} />
            </Typography>
            <Chip
              label={<MappedText text={analysisTypeLabel} />}
              style={{ backgroundColor: "#3E69A9", color: "#FFFFFF" }}
            />
          </Grid>
  
          <Grid item xs={12} sm={6} md={3}>
            <InputLabel>
              <MappedText text={"Status"} />
            </InputLabel>
            <Select
              fullWidth
              sx={{ fontSize: "16px" }}
              value={selectedStatus}
              onChange={handleChangeStatus}
            >
              {uniqueStatusDic.map((status, index) => (
                <MenuItem value={status.value} key={index}>
                  <CircleIcon
                    fontSize="small"
                    style={{ float: "left", color: status.color, padding: "2px" }}
                  />
                  <div style={{ float: "left", display: "block" }}>
                    <MappedText text={status.label} />
                  </div>
                </MenuItem>
              ))}
            </Select>
          </Grid>
  
          <Grid item xs={12} sm={6} md={3}>
            <InputLabel>
              <MappedText text={"Priority"} />
            </InputLabel>
            <Select
              fullWidth
              sx={{ fontSize: "16px" }}
              value={selectedPriority}
              onChange={handleChangePriority}
            >
              {uniquePriorityDic.map((status, index) => (
                <MenuItem value={status.value} key={index}>
                  <CircleIcon
                    fontSize="small"
                    style={{ float: "left", color: status.color, padding: "2px" }}
                  />
                  <div style={{ float: "left", display: "block" }}>
                    <MappedText text={status.label} />
                  </div>
                </MenuItem>
              ))}
            </Select>
          </Grid>
  
          <Grid item xs={12} sm={6} md={3}>
            <DataField
              title="Deadline"
              value={convertDate(allDataApis?.dirs?.deadline) || "NA"}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <DataField title="Assignee(s)" value={allDataApis?.dirs?.assignee || "NA"} />
          </Grid>
        </Grid>
      </>
    );
  }